import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { tap, catchError, retry } from 'rxjs/operators';
import {  StandingOrderModel, OrderTemplate, OrderConsignment, Consignment, HolidayCalendar } from '../../models';
import { HttpClient, HttpHeaders, HttpErrorResponse, HttpParams } from '@angular/common/http';

import {  BoToastrService } from '../../shared';
import { API } from '../config/api';
import { SUCCESS } from '../../../@shared/constants';
import { ErrorResponse, PaginationResponse, PaginationRequest } from '../config/common';
import { requestQuery } from '../../../@shared/untils';

import { of as observableOf } from 'rxjs';
import { ResponseType } from '@angular/http';
import { PaginationStandingOrderRequest, PaginationHolidayCalendarRequest } from './standingorder.DTO';
import { IConsignmentEdit } from '..';

@Injectable()
export class StandingOrderService {

  constructor(
    private _http: HttpClient,
    private _toastr: BoToastrService
  ) { }

  public create(model: StandingOrderModel) {
    return this._http.post(`${API.STANDINGORDERS.CREATE}`, model)
      .pipe(
        tap(() => {
          this._toastr.successCode(SUCCESS.CREATE_STANDINGORDER);
          
        }),
        catchError((err: HttpErrorResponse) => {
          if (!err.error.isEmpty) {
            this._toastr.error(err.error.errors[0]);
          }
          throw err;
        })
      );
  }

  public release(request: any) {
    return this._http.post(`${API.STANDINGORDERS.RELEASE_ORDER}`, request)
      .pipe(
        tap(() => {
        this._toastr.successCode(SUCCESS.RELEASE_ORDER);

        }),
        catchError((err: HttpErrorResponse) => {
          if (!err.error.isEmpty) {
            this._toastr.error(err.error.errors[0]);
          }
          throw err;
        })
      );
  }

  public update(model: StandingOrderModel) {
    return this._http.put(`${API.STANDINGORDERS.UPDATE}`, model)
      .pipe(
        tap(() => {
          this._toastr.successCode(SUCCESS.UPDATE_STANDINGORDER);

        }),
        catchError((err: HttpErrorResponse) => {
          if (!err.error.isEmpty) {
            this._toastr.error(err.error.errors[0]);
          }
          throw err;
        })
      );
  }

  public delete(id: string) {
    return this._http.delete(API.STANDINGORDERS.DELETE(id))
      .pipe(
        tap(() => {
          this._toastr.successCode(SUCCESS.DELETE_STANDINGORDER);
        }),
        catchError((err: ErrorResponse) => {
          this._toastr.errors(err.error.errors);
          throw err;
        })
      )
  }

  public getOne(id: string): Observable<StandingOrderModel> {
    return this._http.get<StandingOrderModel>(`${API.STANDINGORDERS.GET_STANDINGORDER(id)}`).pipe(tap(() => { }),
      catchError((err: ErrorResponse) => {
        this._toastr.errors(err.error.errors);
        throw err;
      })
    )
  }

  public getByCustomer(id: string, startDate: Date, endDate: Date): Observable<OrderTemplate[]> {
    return this._http.get<OrderTemplate[]>(`${API.STANDINGORDERS.GET_STANDINGORDER_BY_CUSTOMER(id, startDate, endDate)}`).pipe(
      tap(() => { }));
  }

  public getByCustomerWithPaging(request: PaginationStandingOrderRequest)
    : Observable<PaginationResponse<OrderTemplate>> {
    
    return this._http.get<PaginationResponse<OrderTemplate>>(
      `${API.STANDINGORDERS.GET_STANDINGORDER_BY_CUSTOMER_PAGING}?${requestQuery(request)}`)
      .pipe(tap(() => { }));
  }


  public getOrderConsignment(orderTemplateId: string, startDate: Date, endDate: Date): Observable<OrderConsignment[]> {
    return this._http.get<OrderConsignment[]>(`${API.STANDINGORDERS.GET_ORDERCONSIGNMENTS_BY_ORDERTEMPLATE(orderTemplateId, startDate, endDate)}`).pipe(
      tap(() => { }));
  }

  public getOrderConsignmentWithPaging(request: PaginationStandingOrderRequest): Observable<PaginationResponse<OrderConsignment>> {
    return this._http.get<PaginationResponse<OrderConsignment>>(
      `${API.STANDINGORDERS.GET_ORDERCONSIGNMENTS_BY_ORDERTEMPLATE_PAGING}?${requestQuery(request)}`)
      .pipe(tap(() => { }));
  }

  public getConsignmentByIdNumber(consignmentIdNumber: number): Observable<any> {
    return this._http.get<any>(`${API.STANDINGORDERS.GET_CONSIGNMENT_BY_IDNUMBER(consignmentIdNumber)}`).pipe(
      tap(() => { }));
  }

  // - Holidays

  public createHoliday(models: HolidayCalendar[]) {
    return this._http.post(`${API.STANDINGORDERS.CREATE_HOLIDAY}`, models)
      .pipe(
        tap(() => {
          this._toastr.successCode(SUCCESS.CREATE_HOLIDAY);

        }),
        catchError((err: HttpErrorResponse) => {
          if (!err.error.isEmpty) {
            this._toastr.error(err.error);
          }
          throw err;
        })
      );
  }

  public updateHoliday(model: HolidayCalendar) {
    return this._http.put(`${API.STANDINGORDERS.UPDATE_HOLIDAY}`, model)
      .pipe(
        tap(() => {
          this._toastr.successCode(SUCCESS.UPDATE_HOLIDAY);

        }),
        catchError((err: HttpErrorResponse) => {
          if (!err.error.isEmpty) {
            this._toastr.error(err.error);
          }
          throw err;
        })
      );
  }

  
  public deleteMonthHoliday(country:string, year: number, month: number) {
    return this._http.delete(API.STANDINGORDERS.DELETE_MONTH_HOLIDAY(country, year, month))
      .pipe(
        tap(() => {
          this._toastr.successCode(SUCCESS.DELETE_HOLIDAY);
        }),
        catchError((err: HttpErrorResponse) => {
          this._toastr.errors(err.error);
          throw err;
        })
      )
  }


  public deleteHoliday(id: string) {
    return this._http.delete(API.STANDINGORDERS.DELETE_HOLIDAY(id))
      .pipe(
        tap(() => {
          this._toastr.successCode(SUCCESS.DELETE_HOLIDAY);
        }),
      catchError((err: HttpErrorResponse) => {
          this._toastr.errors(err.error);
          throw err;
        })
      )
  }

  public getHoliday(id: string): Observable<HolidayCalendar> {
    return this._http.get<HolidayCalendar>(`${API.STANDINGORDERS.GET_HOLIDAY(id)}`).pipe(tap(() => { }),
      catchError((err: ErrorResponse) => {
        this._toastr.errors(err.error.errors);
        throw err;
      })
    )
  }

  public getHolidayByCountry(country: string): Observable<HolidayCalendar[]> {
    return this._http.get<HolidayCalendar[]>(`${API.STANDINGORDERS.GET_HOLIDAY_BY_COUNTRY(country)}`).pipe(
      tap(() => { }));
  }

  public getHolidaysByPaging(request: PaginationHolidayCalendarRequest)
    : Observable<PaginationResponse<HolidayCalendar>> {

    return this._http.get<PaginationResponse<HolidayCalendar>>(
      `${API.STANDINGORDERS.GET_HOLIDAYS_BY_PAGING}?${requestQuery(request)}`)
      .pipe(tap(() => { }));
  }


}
